import styled from 'styled-components'
import {
  COLOR,
  FONT_SIZE
} from '../../themes'
export const StyleMicrosoft = styled.div`
height: calc(100% - 96px);

  .microsoft-button {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #CFB58F;
    border-radius: 8px;
    gap: 18px;
    height: 44px;

    .microsoft-icon-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
    }

    .microsoft-icon {
      width: 24px;
      height: 24px;
    }

    .button-text {
      color: ${COLOR.BLACK_1};
      font-family: NunitoBold;
      font-size: ${FONT_SIZE.XXS};
      letter-spacing: 0.2px;
    }

    &:hover {
      cursor: pointer;
    }
  }
`
